import { render, staticRenderFns } from "./IdeasSection.vue?vue&type=template&id=145a51b4"
import script from "./IdeasSection.vue?vue&type=script&lang=js"
export * from "./IdeasSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports